import { Component, computed, inject, signal } from '@angular/core';
import {
  type ItemView,
  ItemViewProviderDirective,
  Util,
  DataSource
} from '@ntap/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { lastValueFrom, map } from 'rxjs';
import { injectInitialHierarchy } from './queries';

@Component({
  selector: 'app-hierarhija-pozicija',
  template: `
    @if (currentItemId(); as currItemId) { @if (initialHierarchy.query.data();
    as data) {
    <div
      class="flex-column gap-2 pr-2 pl-2 border-1 border-gray-100 border-round-md"
    >
      <div
        class="flex flex-wrap justify-content-end align-content-center gap-2"
      >
        <span class="flex-grow-1">
          <app-current-hierarchy-breadcrumbs
            (onItemSelected)="onItemSelected($event)"
            [itemId]="currItemId"
            [breadcrumbs]="data.breadcrumbs"
          />
        </span>

        <p-button
          class="flex-shrink-1 align-self-center"
          icon="pi pi-sitemap"
          [pTooltip]="tooltip()"
          tooltipPosition="left"
          (onClick)="toggleTreeVisible()"
          [rounded]="true"
          [outlined]="true"
        />
      </div>
      @if (isTreeVisible()) {
      <app-hierarchy-component
        (onItemSelected)="onItemSelected($event)"
        [loading]="initialHierarchy.query.isLoading()"
        [targetIds]="targetIds()"
        [initialData]="data.hierarchy"
      />
      }
    </div>
    } }
  `
})
export class HierarhijaPozicijaComponent {
  private dataSource = inject(DataSource);

  public isTreeVisible = signal(false);
  public tooltip = computed(() =>
    this.isTreeVisible()
      ? 'Zatvorite pregled hijerarhije'
      : 'Otvorite pregled hijerarhije'
  );

  private itemViewProvider = inject(ItemViewProviderDirective<ItemView>);
  public currentItemId = toSignal(
    this.itemViewProvider.item$.pipe(
      map((item) => item as Record<string, unknown>),
      map((item) => item['en~jedinica_gradiva~id'] as number)
    )
  );

  public initialHierarchy = injectInitialHierarchy(() => ({
    id: this.currentItemId() ?? 0
  }));
  public targetIds = computed(
    () => this.initialHierarchy.query.data()?.breadcrumbs.map((b) => b.id) ?? []
  );

  public toggleTreeVisible() {
    this.isTreeVisible.update((curr) => !curr);
  }
  public async onItemSelected(id: number | string) {
    const viewData = await lastValueFrom(
      this.dataSource.getViewData('jedinica_gradiva_default', {
        'en~jedinica_gradiva~id': id
      })
    );
    const nodeBasicData = Util.mapToBasicItemData(viewData);
    this.itemViewProvider.viewState = nodeBasicData[0];
    this.itemViewProvider.reload();
  }
}
